<template>
    <div>
        <span v-if="!inventoryVehicles.data.length">No Data.</span>
        <InventoryVehicleCard
            v-for="vehicle in inventoryVehicles.data"
            :key="vehicle.id"
            :vehicle="vehicle"
            class="mb-4"
        />
        <pagination
            :pagination="inventoryVehicles.meta"
            class="pt-2"
            @current-change="onChangePage"
        />
    </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import InventoryVehicleCard from "@/components/main/inventory/InventoryVehicleCard";

const {mapState} = createNamespacedHelpers('vehicle');
export default {
    components: {InventoryVehicleCard},
    computed: {
        ...mapState(['inventoryVehicles'])
    },
    methods: {
        onChangePage(page) {
            this.$router.push({
                name: this.$route.name,
                query: {
                    ...this.$route.query,
                    page,
                }
            })
        }
    }
}
</script>
